import ApiClient from './ApiClient';

const LONG_OPERATION_TIMEOUT = 20 * 60 * 1000;

export class EditorImageclient extends ApiClient {
  constructor() {
    super('/image-generation/v1');
  }

  async uploadImages(file: File) {
    const formData = new FormData();
    formData.append('file', file);

    return this.client.post('/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      timeout: LONG_OPERATION_TIMEOUT
    });
  }

  async deleteImage(imageId: string) {
    return this.client.delete(`/images/${imageId}`, {
      timeout: LONG_OPERATION_TIMEOUT
    });
  }

  async deleteImageUpload(imageId: string) {
    return this.client.delete(`/upload/${imageId}`, {
      timeout: LONG_OPERATION_TIMEOUT
    });
  }

  async uploadAudio(file: File) {
    const formData = new FormData();
    formData.append('file', file);

    return this.client.post('/audio/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      timeout: LONG_OPERATION_TIMEOUT
    });
  }

  async deleteAudioUpload(audioId: string) {
    return this.client.delete(`/audio/uploads/${audioId}`, {
      timeout: LONG_OPERATION_TIMEOUT
    });
  }

  async addImageToQueue({ imageId, imageUrl, sessionId }: { imageId: string; imageUrl: string; sessionId: string }) {
    return this.client.post(`/canvas-queue`, null, {
      params: {
        image_id: imageId,
        image_url: imageUrl,
        session_id: sessionId
      }
    });
  }

  async getImageFromQueuePrevious(currentItemId: string, currentImageId: string) {
    return this.client.get(`/canvas-queue/previous`, {
      params: {
        current_item_id: currentItemId,
        current_image_id: currentImageId
      }
    });
  }

  async getImageFromQueueNext(currentItemId: string, currentImageId: string) {
    return this.client.get(`/canvas-queue/next`, {
      params: {
        current_item_id: currentItemId,
        current_image_id: currentImageId
      }
    });
  }

  async resumeQueue({ targetImageId, targetItemId }: { targetImageId?: string; targetItemId?: string }) {
    return this.client.post(`/canvas-queue/resume`, null, {
      params: {
        ...(targetImageId ? { target_image_id: targetImageId } : {}),
        ...(targetItemId ? { target_item_id: targetItemId } : {})
      },
      timeout: LONG_OPERATION_TIMEOUT
    });
  }

  async clearQueueSesstion({ sessionId }: { sessionId: string }) {
    return this.client.post(`/canvas-queue/cleanup`, {
      params: { session_id: sessionId }
    });
  }
}

export const editorImageclient = new EditorImageclient();

export default editorImageclient;
